import React, { useState } from 'react';
import { Screen } from '../App';
import * as authApi from '../authApi';
import PasswordInput from '../components/PasswordInput';

interface Props { navigate: (s: Screen) => void; resetToken: string | null; }

export default function ResetPassword({ navigate, resetToken }: Props) {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const handle = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (password.length < 8) { setError('Password must be at least 8 characters.'); return; }
    if (password !== confirm) { setError('The two passwords do not match.'); return; }
    if (!resetToken) { setError('This reset link is invalid or has expired. Please request a new one.'); return; }
    setLoading(true);
    try {
      await authApi.resetPassword(resetToken, password);
      setDone(true);
    } catch (err: any) {
      setError(err?.message || 'Could not reset your password. Please try again.');
      setLoading(false);
    }
  };

  if (!resetToken) {
    return (
      <div className="page-content" style={{paddingTop:60,textAlign:'center'}}>
        <p style={{fontSize:40,marginBottom:16}}>⚠️</p>
        <h1 style={{fontSize:24,marginBottom:12}}>Link not valid</h1>
        <p style={{color:'var(--text-secondary)',fontSize:15,lineHeight:1.7}}>This reset link is invalid or has expired. Please request a new one.</p>
        <button onClick={()=>navigate('forgot')} className="btn-primary" style={{marginTop:24}}>Request a New Link</button>
      </div>
    );
  }

  if (done) {
    return (
      <div className="page-content" style={{paddingTop:60,textAlign:'center'}}>
        <p style={{fontSize:40,marginBottom:16}}>✅</p>
        <h1 style={{fontSize:24,marginBottom:12}}>Password updated</h1>
        <p style={{color:'var(--text-secondary)',fontSize:15,lineHeight:1.7}}>You can now log in with your new password.</p>
        <button onClick={()=>navigate('login')} className="btn-primary" style={{marginTop:24}}>Go to Login</button>
      </div>
    );
  }

  return (
    <div className="page-content" style={{paddingTop:40}}>
      <div style={{textAlign:'center',marginBottom:32}}>
        <h1 style={{fontSize:28,marginBottom:8}}>Choose a new password</h1>
        <p style={{color:'var(--text-secondary)',fontSize:14}}>Enter a new password for your account.</p>
      </div>
      <form onSubmit={handle}>
        <div className="form-group"><label>New Password</label><PasswordInput value={password} onChange={e=>setPassword(e.target.value)} placeholder="At least 8 characters" autoComplete="new-password"/></div>
        <div className="form-group"><label>Confirm Password</label><PasswordInput value={confirm} onChange={e=>setConfirm(e.target.value)} placeholder="Type it again" autoComplete="new-password"/></div>
        {error&&<div style={{background:'var(--coral-light)',color:'var(--coral)',padding:'12px 16px',borderRadius:8,fontSize:14,marginBottom:16}}>{error}</div>}
        <button type="submit" className="btn-primary" disabled={loading}>{loading?'Updating...':'Update Password'}</button>
      </form>
    </div>
  );
}
